var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheHeader',{staticClass:"pc-header"}),_c('BaseTitle',{attrs:{"infor":_vm.infor}}),_c('BaseListUlmoudle2',{staticClass:"product-list-ul",attrs:{"list":_vm.list}}),_c('TheFooter',{staticClass:"pc-the-footer-other"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }